import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManageCharterNotesComponent } from './manage-charter-notes.component';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { AsyncButtonModule } from '../../../../shared/directives/async-button/async-button.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ManageCharterNotesComponent],
  exports: [ManageCharterNotesComponent],
  imports: [
    CommonModule,
    LoadingModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    AsyncButtonModule,
    MatIconModule,
  ],
})
export class ManageCharterNotesModule {}
